module.exports = __webpack_public_path__ + "static/img/20.36217cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/20.png
// module id = pB+N
// module chunks = 6